import * as trace from 'owa-trace';
import changeIsLoading from '../../actions/changeIsLoading';
import clearIsDirty from '../../actions/clearIsDirty';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import saveSenderImageOption from '../../actions/senderImage/saveSenderImageOption';
import SenderImageViewState from 'mini-options-store/lib/store/schema/SenderImageViewState';
import { getOptionsStore } from '../../store/Store';
import { ListViewBitFlagsMasks, setBit } from 'mini-options-store/lib/utils/listViewBitFlagsUtil';
import { orchestrator } from 'satcheljs';
import {
    LIST_VIEW_BIT_FLAGS,
    LIST_VIEW_BIT_TYPE,
    VIEW_STATE_CONFIGURATION,
} from '../../utils/constants';
import updateUserConfiguration, {
    UserConfigurationSetting,
} from '../../services/updateUserConfiguration';

/**
 * Orchestrator is called when we save focused inbox option.
 * Sets isDirty to false.
 */
const saveSenderImageOptionOrchestrator = orchestrator(saveSenderImageOption, async () => {
    const store = getOptionsStore();

    const { isSenderImageEnabled } = store.activeViewState as SenderImageViewState;

    setBit(!isSenderImageEnabled, ListViewBitFlagsMasks.HideSenderImage);

    const userViewStateConfig = getUserConfiguration().ViewStateConfiguration;
    const serviceUpdates: UserConfigurationSetting[] = [];

    serviceUpdates.push({
        propertyName: LIST_VIEW_BIT_FLAGS,
        propertyType: LIST_VIEW_BIT_TYPE,
        propertyValue: `${userViewStateConfig.ListViewBitFlags}`,
    });

    // start loading
    changeIsLoading(true);

    try {
        await updateUserConfiguration(serviceUpdates, VIEW_STATE_CONFIGURATION);
        clearIsDirty();
    } catch (error) {
        trace.errorThatWillCauseAlert(
            `saveSenderImageOptionOrchestrator: Unable to complete the network call. ${error}`
        );
    }
    changeIsLoading(false);
});

export default saveSenderImageOptionOrchestrator;
